import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Main from "./components/Main/Main";
import Form from "./components/Form/Form";
import RGPD from "./components/RGPD/RGPD";



function App() {
  return (
    <div className="App">
      <Form />
      <Main />
      <Footer />
      <RGPD />
    </div>
  );
}

export default App;